import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import { CommonModule } from '@angular/common';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'app-date-picker',
  standalone: true,
  imports: [CommonModule, BsDatepickerModule],
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DatePickerComponent),
    multi: true,
  }],
})
export class DatePickerComponent implements ControlValueAccessor {
  _dateValue: Date;
  notified = false;
  private dateValueChanged = (value: Date) => {};

  @Input() placeholder: string = 'Select Date Range';
  @Input() disabled: boolean = false;
  @Input() resettable: boolean = true;

  @Output('dateChanged') bsValueChange: EventEmitter<Date> = new EventEmitter<Date>();
  @Output('onShown') onShown: EventEmitter<void> = new EventEmitter<void>();
  @Output('onHidden') onHidden: EventEmitter<void> = new EventEmitter<void>();

  set dateValue(range: Date) {
    this._dateValue = range;
    this.dateValueChanged(range);
  }

  get dateValue() {
    return this._dateValue;
  }

  registerOnChange(fn: any): void {
    this.dateValueChanged = fn.bind(this);
  }

  writeValue(range: Date): void {
    if (this.dateValue !== range) {
      this._dateValue = range;
    }
  }

  registerOnTouched(fn: any): void {
  }

  properNotify(date: Date) {
    // weird bsdatepicker will notify on component load
    if (!this.notified) {
      this.notified = true
    } else {
      this.bsValueChange.emit(date);
    }
  }
}
